<div class="maintenance-table-container group-maintenance-table">
  <div class="table-container" [ngClass]="TABLE_CONFIG['TABLE_CLASS']">
    <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-elevation-z8">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [disabled]="disableGlobalCheckBox()"
            style="margin-top: 0.4rem;"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selecttoggle(row) : null"
            [checked]="selection.isSelected(row)"
            [disabled]="disableConditn(row)"
            style="margin-top: 0.4rem;"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="groupname">
        <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: left !important;">
          App Group Name @if (!groupNameFilterApplied) {
          <span
            (click)="filterDropdown('groupname'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (groupNameFilterApplied) {
          <span
            (click)="filterDropdown('groupname'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          style="text-align: left !important;"
          class="hyperlink"
          (click)="groupClicked(element)"
        >
          {{ element.groupname }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Group_Type">
        <th class="groupTypeHeaderPadding" mat-sort-header mat-header-cell *matHeaderCellDef>
          App Group Type @if (!groupTypeFilterApplied) {
          <span
            (click)="filterDropdown('Group_Type'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (groupTypeFilterApplied) {
          <span
            (click)="filterDropdown('Group_Type'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element">{{ element.Group_Type }}</td>
      </ng-container>

      <ng-container matColumnDef="LONG_APP_NAME">
        <th mat-header-cell *matHeaderCellDef style="width: 200px !important;">No Of Applications</th>
        <td mat-cell *matCellDef="let element">{{ appLength(element.applications) }}</td>
      </ng-container>

      <ng-container matColumnDef="Visibility">
        <th class="visibilityHeaderPadding" mat-sort-header mat-header-cell *matHeaderCellDef>
          Visibility @if (!visibilityFilterApplied) {
          <span
            (click)="filterDropdown('Visibility'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
          </span>
          } @if (visibilityFilterApplied) {
          <span
            (click)="filterDropdown('Visibility'); $event.stopPropagation()"
            [matMenuTriggerFor]="contextMenu"
            #trigger="matMenuTrigger"
          >
            <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element">{{ element.Visibility }}</td>
      </ng-container>
      <mat-menu #contextMenu="matMenu">
        <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <input
            matInput
            type="text"
            class="searchoption"
            (keydown)="$event.stopPropagation()"
            class="form-control filter-search-bar"
            [(ngModel)]="searchTxt"
            placeholder="Search"
          />
          <mat-selection-list
            class="filter-list-container"
            (selectionChange)="selectionChange($event)"
            [disableRipple]="true"
            [(ngModel)]="filValue"
          >
            @for (row of filterLists | search : searchTxt; track row) {
            <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
            }
          </mat-selection-list>
          <span
            style="cursor:pointer; float: right;padding-right: 70px;"
            class="small localApplyButton"
            (click)="applyLocalFilter()"
            >Apply</span
          >
          <span
            style="cursor:pointer; float: right;padding-right: 22px;"
            class="small localApplyButton"
            (click)="clearLocalFilter()"
            >Clear</span
          >
        </div>
      </mat-menu>
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef>
          Action &nbsp; @if ((visibilityFilterApplied || groupTypeFilterApplied || groupNameFilterApplied)) {
          <span (click)="clearallFilter()">
            <i
              title="Reset Filters"
              class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
            ></i>
          </span>
          }
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            <div class="btn-edit">
              @if (editCondition(element)) {
              <span class="save-screen-icon" title="edit" (click)="navigateToEditPage(element)">
                <mat-icon class="icon-crud">edit</mat-icon>
              </span>
              } @if (shareCondition(element)) {
              <span class="save-screen-icon" title="share" (click)="navigateToSharePage(element, 'Share')">
                <mat-icon class="icon-crud">share</mat-icon>
              </span>
              } @if (transferCondition(element)) {
              <span (click)="navigateToSharePage(element, 'Transfer')" title="transfer">
                <mat-icon class="uitk-icon uitk-icon-arrows_hollow_left_right sm-icon save-screen-icon icon-crud">
                </mat-icon>
              </span>
              }
              <span title="view" (click)="navigateToViewGroup(element)">
                <mat-icon class="uitk-icon uitk-icon-view sm-icon cancel-screen-icon icon-curd"></mat-icon>
              </span>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <ng-container>
      <mat-paginator
        #paginator
        [pageSizeOptions]="[10, 20, 30]"
        showFirstLastButtons
        aria-label="Select page of listed group"
      >
      </mat-paginator>
    </ng-container>
  </div>
</div>
